import { Box } from "@mui/material"
import { useContext } from "react"
import { AppContext } from "../AppContextProvider"
import CloseSidebarButton from "../navigation/CloseSidebarButton"
import { StyledListWrapper, StyledSidebarDrawer } from "./NonFormikSidebar.styled"
import { NonFormikSidebarProps } from "./Sidebar.interfaces"

const NonFormikSidebar = ({ sidebarId, children, buttonChildren }: NonFormikSidebarProps) => {
  const appContext = useContext(AppContext)
  const isSidebarOpen =
    appContext.isSidebarOpen === sidebarId ||
    appContext.isSidebarOpen === "Default" ||
    appContext.sidebarsOpen[sidebarId]

  const toggleSidebar = () => {
    appContext.toggleSideBar(sidebarId, false)
    appContext.toggleSideBar("Default", false)
    appContext.toggleSideBarMulti(sidebarId, false)
  }

  return (
    <StyledSidebarDrawer variant="persistent" anchor="right" open={isSidebarOpen}>
      <StyledListWrapper sx={{ p: 0 }}>
        <CloseSidebarButton
          toggleMenu={() => {
            toggleSidebar()
          }}
        />
        <Box px={{ xs: 3, sm: 4 }} sx={{ flexGrow: 1, overflow: "auto" }}>
          {children}
        </Box>
        {buttonChildren}
      </StyledListWrapper>
    </StyledSidebarDrawer>
  )
}

export default NonFormikSidebar
